module.exports = __webpack_public_path__ + "static/media/guide-tour-step-7.16e59822.gif";